import React from 'react';
import Image from 'next/image';
import { AiOutlineUpload } from "react-icons/ai";
import { BsSuitHeart } from "react-icons/bs";
import { RiUser6Line } from "react-icons/ri";
import freshArt from "../../public/images/assets/fresh-art.jpg";
import { OpportunityCardContainer } from './opportunity-card-style';
import Link from 'next/link';
import { MdOutlineMail, MdOutlineSensorDoor } from 'react-icons/md';
import { GiHabitatDome, GiSkills } from 'react-icons/gi';
import { VscSymbolMisc } from 'react-icons/vsc';
import { BsCardChecklist, BsPeople } from 'react-icons/bs';
import { MdOutlineVolunteerActivism } from 'react-icons/md';
import { FaRegHandshake } from 'react-icons/fa';
import { IoTelescopeOutline } from 'react-icons/io5';
import { shorten } from '../../util/util';
import { Opportunity, TypesenseOpportunity } from '../../models/user';
import striptags from 'striptags';
import opportunityImg from '../../public/images/assets/opportunity-img.png';
import UseWindowSize from '../../hooks/helper/useWindowSize';
const colors = ['#3d5a80', '#8a817c', '#e0fbfc', '#ee6c4d', '#293241', '#ff9f1c', '#ffbf69', '#2ec4b6', '#f94144', '#f9c74f']
export default function OpportunityCard({ opportunity }: { opportunity: Opportunity | TypesenseOpportunity }) {
    const screenProps = UseWindowSize();
    const RenderIcon = ({ type }) => {
        let icon;
        switch (type) {
            case 'call for entry':
                icon = <FaRegHandshake size={20} />
                break;

            case 'grant':
                icon = <BsCardChecklist size={20} />
                break;

            case 'internship':
                icon = <BsPeople size={20} />
                break;

            case 'job':
                icon = <IoTelescopeOutline size={20} />
                break;

            case 'auditions':
                icon = <VscSymbolMisc size={20} />
                break;

            case 'residencies':
                icon = <GiHabitatDome size={20} />
                break;

            case 'skill-building':
                icon = <GiSkills size={20} />
                break;

            case 'volunteer':
                icon = <MdOutlineVolunteerActivism size={20} />
                break;

            default:
                icon = <FaRegHandshake size={20} />;
        }
        return (icon ? <div>{icon}</div> : <></>)
    }

    return (
        <Link href={`/m/opportunities/o/${opportunity?.id}`} passHref>

            <div className="opportunity-item border d-md-flex justify-content-between pb-2 py-md-0 opportunity-item-1 position-relative cursor-pointer">


                <div className='opportunity-image-wrapper d-flex justify-content-end align-items-center overflow-hidden position-relative col-md-3  blur-layer' style={{ background: `url(${opportunity?.image?.trim()?.length > 0 ? opportunity?.image : opportunityImg.src})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>

                    <div className='glassmorphic h-100 w-100 position-relative'>
                        <div className='h-100 w-100 position-absolute' style={{ zIndex: 10, background: `url(${opportunity?.image?.trim()?.length > 0 ? opportunity?.image : 'https://cdn.fleato.org/fresharts/pinned/oppboard.jpg'})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center' }}>

                        </div>
                    </div>
                </div>
                <div className='col-md-9'>
                    <div className="opportunity-card-details p-4 position-relative">
                        <div className='d-md-flex justify-content-between align-items-start'>
                            <p className="opportunity-card-title  text-center text-md-left mb-0">
                                {shorten(`${opportunity?.name}`, 80)}
                            </p>
                            <div className='d-none d-md-flex justify-content-end align-items-center px-2 col-2' >
                                <RenderIcon type={opportunity?.opportunityType} />

                            </div>
                        </div>

                        <p className='small-text grey-text  text-center text-md-left overflow-hidden' style={{ maxHeight: screenProps?.windowSize?.width >= 768 ? 100 : 40 }}>
                            {opportunity?.discipline?.map((value, index) => `${value}${index + 1 != opportunity?.discipline?.length ? ',' : ''}`)}</p>
                        <p className='fa-color mb-3 description-text'>{shorten(striptags(opportunity?.description), screenProps?.windowSize?.width >= 768 ? 300 : 100)}</p>
                        {/* <p className="grey-text mb-2"></p> */}
                        <div className="mt-2">
                            <div className="d-flex mb-2">
                                <MdOutlineSensorDoor size={20} className='me-2 cursor-pointer' />
                                <p className="uppercase mb-0 fw-600">Closing on: {new Date(opportunity?.date).toISOString().substring(0, 10)}</p>
                            </div>
                            {opportunity?.email ? <div className="d-flex">
                                <MdOutlineMail size={20} className='me-2 cursor-pointer' />
                                <p className="mb-0 fw-600">{opportunity?.email}</p>
                            </div> : null}
                        </div>
                    </div>
                </div>

            </div>
        </Link>
    )
};